module.exports = __webpack_public_path__ + "static/media/MTL_SL_MANGANESE2.f11b4091.png";